import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-link-device-dialog',
  templateUrl: './link-device-dialog.component.html',
  styleUrls: ['./link-device-dialog.component.css']
})
export class LinkDeviceDialogComponent {
  device_id: number;
  constructor(
    public dialogRef: MatDialogRef<LinkDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    onNoClick(): void {
      this.dialogRef.close();
    }

}


// WEBPACK FOOTER //
// ./src/app/link-device-dialog/link-device-dialog.component.ts